import * as React from "react";
import { observer } from "mobx-react-lite";
import type { StackProps} from "@chakra-ui/react";
import { Box, useBreakpointValue, VStack, Flex } from "@chakra-ui/react";
import type { IPropsText, TextPreset } from "../../components/Text";
import type { IPropsTitle } from "../../components/Title";
import { Title } from "../Title";
import { Text } from "../Text";

interface IProps {
	children?: React.ReactNode;
	title?: string;
	description?: string;
	stackContainerProps?: StackProps;
	invert?: boolean;
	textProps?: Partial<IPropsText>;
	titleProps?: Partial<IPropsTitle>;
	left?: boolean;
}

export const DataCard: React.FC<IProps> = observer((props) => {
	const { title, description, children, invert, stackContainerProps = { spacing: "40px" }, textProps, titleProps, left} = props;
	const textPreset = useBreakpointValue<TextPreset>({
		base: "preset3",
		lg: "preset4",
	});


	return (
		<VStack {...stackContainerProps}>
			<VStack
				spacing='8px'
				alignItems={{
					base: "flex-start",
					lg: (left ? "left" : "center"),
				}}
				textAlign={{base: "start", lg: (left ? "left" : "center")}}
			>
				{invert ?
					<Flex flexDirection="column" alignItems="flex-start">
						<Text
							preset={textPreset || "preset3"}
							fontWeight={"regular"}
							{...textProps}
						>
							{description}
						</Text>
						<Title preset={"preset6"} {...titleProps}>
							{title}
						</Title>
					</Flex>
					:
					<>
						{title && <Title preset={"preset6"} {...titleProps}>
							{title}
						</Title>}
						<Text
							preset={textPreset || "preset3"}
							fontWeight={"regular"}
							{...textProps}
						>
							{description}
						</Text>
					</>
				}
			</VStack>

			{children && (
				<Box width="full">
					{children}
				</Box>
			)}
		</VStack>
	);
});
